import React from 'react';
import { createRoot } from 'react-dom/client';

import Routes from './routes/';

import '../sass/main.scss';
import 'material-icons/iconfont/material-icons.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'codemirror/theme/xq-light.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import 'swagger-ui-react/swagger-ui.css';

import CodeMirror from 'codemirror';
import { LicenseInfo } from '@mui/x-data-grid-pro';

import Auth from './data/auth-service';

// to add custom mode
import Suricata from './codemirror/mode/suricata';
import Gator from './codemirror/mode/gator';
import ZeekScript from './codemirror/mode/zeekscript';
CodeMirror.defineMode('suricata', Suricata);
CodeMirror.defineMode('gator', Gator);
CodeMirror.defineMode('zeek', ZeekScript);

// to add built-in mode
// require('codemirror/mode/xml/xml');
// require('codemirror/mode/javascript/javascript');

LicenseInfo.setLicenseKey('119892309d55a959dbcf524836d1ef24Tz0xMTI4NDcsRT0xNzc5NjY3MjAwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=');

const LSCHECK = (process.env.BRICATA_APPLIANCE_TYPE === 'ls');

if (LSCHECK) {
    document.title = document.title + ' - License Server';
} else if (process.env.BRICATA_APPLIANCE_TYPE === 'mc2') {
    document.title = document.title + ' - MC2';
} else {
    document.title = document.title + ' - CMC';
}

const renderApp = () => {
    const app = createRoot(document.getElementById('app'));
    app.render(<Routes />);
};

if (LSCHECK) {
    renderApp();
} else {
    Auth.getPermConstants().then(() => {
        Auth.getPermDescriptions().then(() => {
            renderApp();
        });
    });
}
